module.exports = {
      id: "jokes-usage",
      viewBox: "0 0 32 19.2",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#jokes",
      toString: function () {
        return this.url;
      }
    }